import axios from '../utils/request'

const api = {
    // 获取用户信息
    getUserInfo() {
        return axios.get('/user/user_info')
    },
    // 获取成员列表
    getTeamList() {
        return axios.get('/user/v1/members')
    },
    addUser(data) {
        return axios({
            url: '/user/v1/add',
            method: 'post',
            data
        })
    },
    editUser(data, params) {
        return axios({
            url: '/user/v1/update',
            method: 'post',
            params,
            data
        })
    },
    resetPwd(data, params) {
        return axios({
            url: '/user/v1/modify/pwd',
            method: 'post',
            data,
            params
        })
    },
    assignTask(data) {
        return axios({
            url: '/user/v1/assign_task',
            method: 'post',
            data
        })
    },
    deleteUser(params) {
        return axios({
            url: '/user/v1/delete',
            method: 'delete',
            params
        })
    },
    uploadAvatar(data) {
        return axios({
            url: '/file/upload',
            method: 'post',
            data
        })
    },
    getAvatar(id) {
        return axios.get('/file/download?file_uuid=' + id, { responseType: "arraybuffer" })
    },
    loginOut() {
        return axios({
            url: '/logout/v1/',
            method: 'get'
        })
    },
    assginUser(data) {
        return axios({
            url: '/tasks/v1/assign_owner',
            method: 'post',
            data
        })
    },
    getTaskList(data) {
        return axios({
            url: '/tasks/v1/list/by_user',
            method: 'post',
            data
        })
    }
}
export default api